import request from '@/utils/request'

// 详情
export function apiBomRoutingHeaderId (id) {
  return request({
    url: `/bom/bomRoutingHeader/${id}`,
    method: 'get'
  })
}

// 工艺路线
export function apiBomRoutingHeaderFindList (query) {
  return request({
    url: `/bom/bomRoutingHeader/findList`,
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiBomRoutingHeaderNewExport (data) {
  return request({
    url: '/bom/bomRoutingHeader/v2/export_line',
    method: 'post',
    data: data
  })
}

// 工序编码
export function apiBomOperationFindList (query) {
  return request({
    url: '/bom/bomOperation/findList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiBomRoutingHeaderUpdate (data) {
  return request({
    url: '/bom/bomRoutingHeader',
    method: 'put',
    data: data
  })
}

// 新增
export function apiBomRoutingHeaderAdd (data) {
  return request({
    url: '/bom/bomRoutingHeader',
    method: 'post',
    data: data
  })
}
